import { ProcessingJobType } from "@prisma/client";
import { ProcessingJobData } from "@/app/types/job/ProcessingJob";
import { Globals } from "../vars/Globals";

export class UJobPolling {
  public static getCallAnalysisInterval(
    jobs: ProcessingJobData[] | undefined,
    options: {
      isCallAnalysisPage?: boolean;
    } = {},
  ): number | false {
    if (!jobs || jobs.length === 0) return false;

    const { isCallAnalysisPage = false } = options;
    const hasAnalysisJob = jobs.some((job) => job.type === ProcessingJobType.CALL_ANALYSIS);

    if (isCallAnalysisPage && hasAnalysisJob) {
      return Globals.ACTIVE_JOB_POLLING_INTERVAL_MS;
    }

    return false;
  }
}
